module.exports = __webpack_public_path__ + "img/centralized-password-vault4.ae7a8f73.jpg";